import React, { useContext, useState } from "react";
import { Button } from "semantic-ui-react";

import { RootStoreContext } from "../../../app/stores/rootStore";

import { documentsConfigurations } from './constants';


const ResetSetTestDocumentIdModal = ({ activeDocumentState, activeDocument }) => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { closeModal } = rootStore.modalStore;
  const { rebootTestSetDocument } = rootStore.companyStore;
  const [rebootTestSetDocLoading, setRebootTestSetDocLoading] = useState(false);

  const handleRebootTestSetDocument = () => {
    const body = {
      testSetId: activeDocumentState?.id,
      documentType: documentsConfigurations[activeDocument].id,
    };

    setRebootTestSetDocLoading(true);
    rebootTestSetDocument(body);
  };

  return (
    <div className="modalContent">
      <label>Al aceptar el cambio del identificador, se reiniciará todo el proceso del set de pruebas</label>
      <br />
      <br />
      <label>¿Desea de continuar? </label>
      <Button color="red" inverted onClick={() => closeModal()}>
        No
      </Button>
      <Button
        positive
        onClick={handleRebootTestSetDocument}
        icon="checkmark"
        content="Si"
        loading={rebootTestSetDocLoading}
        disabled={rebootTestSetDocLoading}
      />
    </div>
  );
};
export default ResetSetTestDocumentIdModal;